/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setIssuedCardEnabled} from '../api'

export const useMutationSetIssuedCardEnabled = createReactQueryMutationHook('setIssuedCardEnabled', setIssuedCardEnabled)
